module.exports = __webpack_public_path__ + "img/page-home-banner-img1.e22baebd.png";